// @import dependencies
import { store } from 'app_storage/redux-storage'
// @end

// @import event types
import { AuthActionTypes, CHANGE_SCREEN_MODE, LOGIN, LOGOUT, MOODLE_AUTH, MOODLE_FORM_REQUEST, UPDATE_TOKEN, UPDATE_USER_DATA, UPDATE_USER_STORE } from './types';
// @end

// @import utils
// @end

// @import services
import UserService from 'app_services/user/userService'
// @end

// @import types
import { IUser } from 'app_types/userTypes'
import { IUserData } from 'app_types/userTypes';
// @end

// @add your events

/*===============================================
=            Estructura de un metodo            =
================================================
  // La estructura de un metodo debe ser la siguiente:
  export const methodName = () => {}
/*======  End of Estructura de un metodo  =====*/

export function login(user: IUser): AuthActionTypes {
  return {
    type: LOGIN,
    payload: user,
  }
}

export function logout(): AuthActionTypes {
  return {
    type: LOGOUT,
    payload: null,
  }
}

export function updateToken(token: string): AuthActionTypes {
  return {
    type: UPDATE_TOKEN,
    payload: token,
  }
}

export const changeScreenModeAction = (mode: string) => (
  async (dispatch: Function) => {
    const user = {...store.getState().auth.user}
    // const userService = new UserService()

    try {
      // const response = await userService.changeScreenMode(mode)

      // if(response.status === 'success'){
        // @ts-ignore
        user.data.screen_mode = mode
        dispatch(changeScreenMode(user))
      // }else{}
    } catch (error) {}
  }
)

export const updateUserDataAction = (data: IUserData) => {
  return (dispatch: Function) => {
    dispatch(updateUserData(data));
  }
}

export const updateUserStoreAction = (data: IUser) => {
  return (dispatch: Function) => {
    dispatch(updateUserStore(data));
  }
}

const updateUserData = (data: IUserData) => ({
  type: UPDATE_USER_DATA,
  payload: data
})
const updateUserStore = (data: IUser) => ({
  type: UPDATE_USER_STORE,
  payload: data
})

const changeScreenMode = (user: any) => ({
  type: CHANGE_SCREEN_MODE,
  payload: user,
})

export const moodleAuthChange = (sessionActive: boolean) => ({
  type: MOODLE_AUTH,
  payload: sessionActive
})
export const moodleAuthFormRequest = (request: boolean) => ({
  type: MOODLE_FORM_REQUEST,
  payload: request
})

//@end
